var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.226 16.136L5.363 9.739c-.617-.673-.14-1.759.774-1.759h11.726c.914 0 1.392 1.086.774 1.76l-5.863 6.396a1.05 1.05 0 01-1.548 0z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMS4yMjYgMTYuMTM1Nkw1LjM2Mjg4IDkuNzM5NDlDNC43NDU1NCA5LjA2NjAyIDUuMjIzMjkgNy45Nzk5OCA2LjEzNjkgNy45Nzk5OEgxNy44NjMxQzE4Ljc3NjcgNy45Nzk5OCAxOS4yNTQ1IDkuMDY2MDIgMTguNjM3MSA5LjczOTQ5TDEyLjc3NCAxNi4xMzU2QzEyLjM1NzkgMTYuNTg5NiAxMS42NDIxIDE2LjU4OTYgMTEuMjI2IDE2LjEzNTZaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { Svg24 as ReactComponent };